<div class="menu-item">
  @switch (item.type) { @case ('section') {
  <acs-menu-toggle
    [section]="item"
    (menuChanged)="onSubMenuToggled($event)"
    (registerSubToggle)="registerToggle($event)"
    [showIcon]="true"
  >
  </acs-menu-toggle>
  } @case ('form') {
  <acs-form-link [formId]="item.formEnumId" [showIcon]="true"></acs-form-link>
  } @default {
  <div>
    <button mat-button color="warn" [disabled]="true">{{ item.name }}</button>
  </div>
  } }
</div>
